import { CardHeader, useTheme } from "@mui/material";
import React, { FC, ReactNode } from "react";
import FeatherIcon from "feather-icons-react";

import CardGuide from "../../CardGuide";

import { Grid, Tooltip, Typography } from "@components/base";

interface CardGuideHeader {
  title: CardGuide["title"];
  titleTooltip: CardGuide["titleTooltip"];
  children?: ReactNode;
}

const CardGuideHeader: FC<CardGuideHeader> = ({ title, titleTooltip, children }) => {
  const theme = useTheme();

  return (
    <CardHeader
      className="card-header"
      title={
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid gap={1} container alignItems="center">
            <Typography variant="subtitle1">{title}</Typography>
            <Tooltip title={titleTooltip} color={theme.palette.main[500]}>
              <FeatherIcon icon="info" size="16" />
            </Tooltip>
          </Grid>
          {children}
        </Grid>
      }
    />
  );
};

export default CardGuideHeader;
